export const es = {
  // Navigation
  nav: {
    home: "Inicio",
    contact: "Contacto",
    bookNow: "Reservar ahora",
    emergency: "Emergencia 24/7",
    legalNotice: "Aviso Legal",
    implants: "Implantes",
    veneers: "Carillas",
    technology: "Tecnologías",
    book: "Reservar ahora",
    close: "Cerrar"
  },

  // Common
  common: {
    bookNow: "Reservar ahora",
    date: "Fecha",
    time: "Hora",
    close: "Cerrar"
  },

  // Header
  header: {
    logoText: "SeaDent Mallorca",
    phone: "603 31 96 48",
    whatsapp: "WhatsApp",
    languageToggle: "ES",
    reviews: {
      rating: "5.0",
      count: "470+ reseñas",
      google: "Reseñas de Google"
    }
  },

  // Hero Section
  hero: {
    title: "SeaDent Mallorca: Tu sonrisa importa.",
    subtitle: "Odontología moderna con empatía. Ambiente relajado, resultados excelentes.",
    cta: "Reservar cita online",
    banner: {
      title: "Experimenta un confort personalizado",
      subtitle: "(y descubre por qué a nuestros pacientes les encanta volver)",
      buttons: {
        cosmetic: "Odontología Estética",
        pediatric: "Odontopediatría",
        general: "Odontología General",
        whitening: "Blanqueamiento Dental"
      }
    }
  },

  // Booking Wizard (3-step flow)
  bookingWizard: {
    steps: {
      treatment: "¿Qué tipo de cita necesita?",
      insurance: "Seleccione su seguro",
      dateTime: "Elija la fecha y hora preferidas"
    },
    treatments: {
      cleaning: "Limpieza Dental Profesional + Examen (Doctor)",
      returningCleaning: "Limpieza Dental para Pacientes Recurrentes (Higienista Dental Registrado) + Examen (Doctor)",
      consultation: "Consulta Dental General (Doctor)",
      cosmetic: "Consulta Dental Estética (Doctor)",
      secondOpinion: "Segunda Opinión en Consulta Dental (Doctor)",
      emergency: "Cita Dental de Urgencia (Radiografías + Examen del Doctor)",
      whitening: "Tratamiento de Blanqueamiento Dental Profesional",
      botox: "Consulta de Botox (Doctor)",
      tmj: "Consulta de ATM (Dolor de Mandíbula) (Doctor)",
      pediatric: "Odontopediatría (Odontología para Niños)"
    },
    insurance: {
      search: "Introduzca su seguro",
      none: "No tengo seguro"
    },
    navigation: {
      back: "Atrás",
      next: "Siguiente",
      close: "Cerrar"
    },
    getDirections: "Cómo llegar",
    instantBookingBy: "Reserva instantánea por"
  },

  // Form structure used in Step 3 and elsewhere
  booking: {
    title: "Reservar cita",
    subtitle: "Programe su visita con nuestro equipo de expertos",
    form: {
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Número de teléfono",
      message: "Mensaje (opcional)",
      submit: "Confirmar reserva",
      submitting: "Enviando...",
      success: "¡Gracias! Su cita ha sido confirmada.",
      error: "Se ha producido un error al realizar la reserva. Por favor, inténtelo de nuevo."
    }
  },

  // Cookie Consent
  cookieConsent: {
    title: "Aviso de Cookies",
    description: "Utilizamos cookies para mejorar su experiencia en nuestro sitio web. Al utilizar nuestro sitio web, acepta nuestra política de cookies.",
    acceptAll: "Aceptar Todo",
    acceptNecessary: "Solo Necesarias",
    settings: "Configuración",
    save: "Guardar",
    close: "Cerrar",
    privacyPolicy: "Política de Privacidad",
    categories: {
      necessary: {
        title: "Necesarias",
        description: "Estas cookies son necesarias para el funcionamiento del sitio web y no pueden ser desactivadas."
      },
      preferences: {
        title: "Preferencias",
        description: "Estas cookies permiten que el sitio web recuerde las elecciones que ha realizado."
      },
      statistics: {
        title: "Estadísticas",
        description: "Estas cookies nos ayudan a comprender cómo interactúan los visitantes con el sitio web."
      },
      marketing: {
        title: "Marketing",
        description: "Estas cookies se utilizan para proporcionar a los visitantes anuncios y campañas de marketing relevantes."
      }
    }
  },

  // Footer
  footer: {
    legal: {
      title: "Aviso legal",
      privacy: "Política de privacidad",
      cookieSettings: "Configuración de cookies"
    },
    links: {
      title: "Enlaces",
      home: "Inicio",
      contact: "Contacto",
      book: "Reservar cita"
    },
    contact: {
      title: "Contacto",
      practice: "SeaDent Mallorca",
      address: "Avenida de Jaime III № 3",
      city: "07012 Palma, Mallorca",
      owner: "Inhaber: Jan D. Heiringhoff",
      phone: "603 31 96 48",
      whatsapp: "WhatsApp: 603 31 96 48",
      email: "info@seadent.es",
      hours: "Lun-Vie: 09:00 - 18:00"
    },
    copyright: "© 2025 SeaDent Mallorca. Todos los derechos reservados."
  },

  // Contact Page content
  contact: {
    title: "Contacto",
    subtitle: "Estaremos encantados de responder a sus preguntas",
    contactInfo: "Información de contacto",
    phone: "Teléfono",
    address: "Dirección",
    email: "Correo electrónico",
    emergencyTitle: "Urgencias",
    emergencyText: "Servicio 24 horas disponible para urgencias",
    appointment: "Cita previa",
    findUsTitle: "Dónde estamos",
    directionsButton: "Cómo llegar",
    transportTitle: "Cómo llegar",
    publicTransport: "Transporte público",
    publicTransportInfo: "Estamos situados en el centro de Palma, cerca de las principales paradas de autobús de Jaime III.",
    byCar: "En coche",
    byCarInfo: "Hay varios aparcamientos públicos cercanos, como el Parking Vía Roma y El Corte Inglés."
  },

  // Emergency Page
  emergency: {
    title: "Servicio de Urgencias Dentales 24/7",
    subtitle: "Estamos aquí para ayudarle las 24 horas del día",
    intro: "Si experimenta una urgencia dental, póngase en contacto con nosotros inmediatamente. Nuestro equipo de urgencias está disponible las 24 horas del día para brindarle la atención que necesita.",
    call: "Llamar ahora",
    whatsapp: "WhatsApp",
    cta: "Llamar al 603 31 96 48",
    details: [
      {
        title: "Disponibilidad",
        description: "Nuestro equipo de urgencias está disponible las 24 horas del día, los 365 días del año, incluidos fines de semana y festivos."
      },
      {
        title: "Contacto",
        description: "Llámenos al 603 31 96 48 para asistencia inmediata. También aceptamos mensajes de WhatsApp."
      },
      {
        title: "Urgencias comunes",
        description: "Tratamos dolores dentales intensos, dientes rotos, pérdida de piezas dentales y otros traumatismos dentales."
      },
      {
        title: "Servicio",
        description: "Brindamos alivio inmediato del dolor y soluciones a largo plazo utilizando la última tecnología dental."
      }
    ],
    common: {
      title: "Urgencias dentales comunes",
      toothache: "Dolor dental intenso",
      broken: "Diente roto o astillado",
      knocked: "Diente caído",
      bleeding: "Sangrado de encías",
      swelling: "Hinchazón facial",
      lost: "Empaste o corona perdida"
    }
  },

  // Treatments Section
  treatments: {
    title: "Tratamientos: Su sonrisa en las mejores manos",
    intro: "Nuestros tratamientos en SeaDent Mallorca cubren todo el espectro de la odontología moderna, desde la prevención hasta la perfección estética. Con tecnología avanzada y un cuidado empático, garantizamos su salud oral y una sonrisa radiante.",
    cta: "Reservar cita",
    categories: [
      {
        title: "Prevención y Profilaxis",
        description: "Controles periódicos y medidas preventivas para una salud bucodental a largo plazo. Apostamos por el asesoramiento individual y el diagnóstico moderno.",
        treatments: [
          {
            title: "Control y asesoramiento",
            description: "Exámenes detallados y recomendaciones personales para unos dientes sanos."
          },
          {
            title: "Limpieza dental profesional",
            description: "Eliminación profunda de la placa dental para una sensación de limpieza y frescura."
          },
          {
            title: "Empastes",
            description: "Empastes de alta calidad que restauran sus dientes estética y funcionalmente."
          },
          {
            title: "Profilaxis infantil",
            description: "Prevención adaptada a los niños para proteger sus dientes de forma lúdica."
          }
        ]
      },
      {
        title: "Terapia del Dolor",
        description: "Tratamientos indoloros mediante técnicas suaves y las últimas tecnologías. Su bienestar es el centro de cada sesión.",
        treatments: [
          {
            title: "Tratamiento del dolor",
            description: "Alivio rápido y eficaz del dolor dental, adaptado individualmente a usted."
          },
          {
            title: "Extracción dental",
            description: "Extracción suave de dientes cuando no es posible otra solución."
          },
          {
            title: "Endodoncia",
            description: "Endodoncia precisa para salvar dientes inflamados y aliviar el dolor."
          },
          {
            title: "Problemas de la mandíbula",
            description: "Terapia específica para problemas de la articulación temporomandibular (ATM) para una mejor calidad de vida."
          }
        ]
      },
      {
        title: "Periodoncia",
        description: "Tratamiento profesional de las enfermedades de las encías para una salud bucodental estable. Las medidas tempranas evitan daños a largo plazo.",
        treatments: [
          {
            title: "Medidas de tratamiento",
            description: "Limpieza profesional y terapias para combatir eficazmente la inflamación de las encías."
          }
        ]
      },
      {
        title: "Para una sonrisa perfecta (Estética)",
        description: "Soluciones estéticas para una sonrisa segura, totalmente según sus deseos. Nuestros métodos son suaves y eficaces.",
        treatments: [
          {
            title: "Invisalign",
            description: "Alineadores transparentes para una corrección dental discreta y cómoda."
          },
          {
            title: "Blanqueamiento dental",
            description: "Blanqueamiento suave de sus dientes para una sonrisa blanca y radiante."
          },
          {
            title: "Férulas de descarga",
            description: "Férulas a medida para prevenir el bruxismo y proteger su dentadura."
          },
          {
            title: "Carillas",
            description: "Láminas de cerámica extrafinas para un aspecto perfecto y natural de sus dientes."
          },
          {
            title: "Coronas y puentes",
            description: "Prótesis dentales de alta calidad para la función y la estética en dientes dañados."
          }
        ]
      },
      {
        title: "Implantes",
        description: "La tecnología de implantes más moderna para una prótesis dental natural y duradera. Nuestros implantes le ofrecen comodidad y seguridad.",
        treatments: [
          {
            title: "Implantes individuales",
            description: "Sustitución de dientes individuales con implantes de alta calidad para una sensación natural."
          },
          {
            title: "Implantes múltiples",
            description: "Soluciones integrales de implantes para huecos dentales mayores o hileras de dientes completas."
          },
          {
            title: "Implantes inmediatos",
            description: "Implantes de carga inmediata para una rápida restauración de su función masticatoria."
          }
        ]
      }
    ]
  },

  // Benefits Section
  benefits: {
    title: "Sus beneficios: Excelencia, comodidad y una sonrisa radiante.",
    items: [
      {
        title: "Experiencia y competencia",
        description: "Dentistas cualificados con formación continua constante."
      },
      {
        title: "Tecnología de vanguardia",
        description: "Tratamientos precisos con radiografía digital y equipos innovadores."
      },
      {
        title: "Atención centrada en el paciente",
        description: "Tratamiento empático, como el que esperaría de un amigo."
      },
      {
        title: "Ambiente mediterráneo",
        description: "Un entorno relajado inspirado en la belleza de Mallorca."
      },
      {
        title: "Servicio multilingüe",
        description: "Tratamiento en alemán, inglés, español y ruso."
      },
      {
        title: "Ubicación central",
        description: "Fácilmente accesible en el corazón de Palma de Mallorca."
      }
    ]
  },

  // Approach Section
  approach: {
    title: "Odontología reinventada: Su bienestar, nuestra promesa.",
    text: "En SeaDent queremos que su visita al dentista sea algo especial. Nuestra misión es ofrecerle no solo tratamientos médicamente excelentes, sino también un ambiente en el que se sienta relajado y comprendido. Para nosotros esto significa:",
    points: [
      "Escuchamos: sus deseos y necesidades están en el centro de nuestra atención. Nos tomamos tiempo para un asesoramiento individual.",
      "Relajación y tratamientos indoloros: con los métodos más modernos y el enfoque en su bienestar, hacemos que los tratamientos sean lo más cómodos posible.",
      "La transparencia crea confianza: explicamos cada paso de su tratamiento de forma clara y comprensible para que se sienta seguro."
    ]
  },

  // Experience Section
  experience: {
    title: "Sus momentos de bienestar en SeaDent Mallorca.",
    text: "En SeaDent se trata de algo más que odontología: queremos que su visita se convierta en un momento de relajación. Nuestra clínica combina los tratamientos más modernos con un ambiente inspirado en la paz y la belleza de Mallorca.",
    points: [
      "Ambiente acogedor con colores mediterráneos y luz natural.",
      "Equipo amable y empático que le ofrece una cálida bienvenida.",
      "Tiempos de espera cortos gracias a una organización eficiente de la clínica.",
      "Zonas de espera cómodas con Wi-Fi, bebidas y plantas.",
      "Detalles relajantes como música suave durante el tratamiento."
    ]
  },

  // Social Proof Section
  socialProof: {
    title: "Lo que dicen nuestros pacientes",
    reviews: [
      {
        text: "Profesionalmente de primera, humanamente grandioso, aquí uno se siente realmente bien cuidado ❤️. Un enorme agradecimiento al dentista y a todo el equipo. Así es como me imagino una clínica moderna y acogedora 🦷🤗.",
        author: "Marcel"
      },
      {
        text: "Nunca he conocido a un dentista tan dedicado, cálido y honesto. Siempre se toma mucho tiempo, incluso fuera del horario habitual de la clínica, y está siempre disponible para sus pacientes. Los tratamientos son profesionales y se realizan con mucha empatía. Incluso después de la cita, se ocupa del seguimiento y quiere saber cómo te encuentras; eso es algo que no se puede dar por sentado. Un dentista absolutamente fantástico en el que puedes confiar plenamente. ¡Recomendación absoluta!",
        author: "Stefanie"
      },
      {
        text: "¡¡¡Dentista de primera!!! Por supuesto, tuve un dolor de muelas extremo justo durante las vacaciones después de un empaste que me habían hecho hacía unas semanas. No era posible esperar hasta que pudiera ir a mi dentista en Alemania. Conseguí una cita con Jan D. Heiringhoff de inmediato. Es súper simpático, escucha, hace preguntas y realizó el tratamiento de conducto necesario de forma excelente. Mi dentista en Alemania dijo después que hizo un trabajo estupendo con el tratamiento de conducto. No tuve problemas ni siquiera dolor durante o después del tratamiento. ¡Lo recomiendo totalmente!",
        author: "Hendrik"
      },
      {
        text: "Realmente me alegré mucho de recibir una respuesta rápida y sin complicaciones después de una noche sin dormir por un dolor de muelas agudo. El tratamiento también fue rápido y profesional. Es agradable que todavía haya médicos que trabajen también los sábados y que, además, sean muy amables y competentes. Muchas gracias.",
        author: "T."
      },
      {
        text: "Tratamiento de urgencia inmediato (!) y profesional. Transparente y de tú a tú. Muchas gracias al equipo, me sentí muy bien atendido. ADENDA (unos meses después): De vuelta en la clínica, esta vez para un blanqueamiento. Todo profesional y amable. ¡Simplemente una clínica recomendable! 👍",
        author: "Hubert"
      },
      {
        text: "Fui recibido y atendido con muchísima amabilidad. El Dr. Heiringhoff se tomó mucho tiempo y me lo explicó todo detalladamente. A petición mía, hizo 2 radiografías de mi nueva corona. Tenía miedo de tener una infección en la raíz. No fue así y pude irme tranquila. Recomiendo sin duda al Dr. Heiringhoff. Gracias por la rápida ayuda un domingo ☺️.",
        author: "Elke"
      },
      {
        text: "Sinceramente, mis dientes daban pena antes, tanto que prefería posar serio en las fotos antes que sonreír. ¡Pero entonces llegó Jan! El tío convirtió mi dentadura en una sonrisa digna de ver. Súper relajado, nada de miedo al dentista y con mucho amor por el detalle. Ahora vuelvo a sonreír como si acabara de salir de un anuncio de pasta de dientes. ¡Gracias, Jan, eres mi héroe dental!",
        author: "Patrick"
      },
      {
        text: "Muchas gracias por la rápida ayuda. Tuve una urgencia dental durante las vacaciones. Conseguí una cita de inmediato, donde me asesoraron y atendieron de maravilla. Recomendación de corazón.",
        author: "Simone"
      }
    ]
  },

  // CTA Section
  cta: {
    title: "Experimente una odontología que le dé prioridad.",
    text: "¿Está listo para una clínica dental que combine el profesionalismo con el confort mediterráneo? Reserve su cita en SeaDent Mallorca y descubra un nuevo tipo de odontología – ¡esperamos darle la bienvenida en Palma!",
    bookButton: "Reservar cita online",
    callButton: "Llámenos",
    visitInfo: "Visítenos: Avenida de Jaime III № 3, Palma, Mallorca."
  },

  // Services (Home page cards)
  services: {
    title: "Nuestros Servicios",
    subtitle: "Odontología Integral",
    implants: {
      title: "Implantes Dentales",
      description: "Solución duradera para la falta de dientes con implantes de titanio"
    },
    veneers: {
      title: "Carillas",
      description: "Transforme su sonrisa con carillas de porcelana personalizadas"
    },
    cleaning: {
      title: "Limpieza Profesional",
      description: "Limpieza profunda y prevención para una salud oral óptima"
    },
    crown: {
      title: "Coronas y Puentes",
      description: "Restauración de dientes dañados con coronas y puentes de alta calidad"
    },
    orthodontics: {
      title: "Ortodoncia",
      description: "Alinee sus dientes con tratamientos ortodónticos modernos"
    },
    surgery: {
      title: "Cirugía Oral",
      description: "Intervenciones quirúrgicas expertas en nuestros modernos quirófanos"
    }
  },

  // Technologies Section
  technologies: {
    title: "Tecnología Moderna",
    subtitle: "Equipamiento de última generación",
    intro: "En SeaDent, priorizamos una odontología personal, agradable e indolora mediante el uso de tecnología de vanguardia.",
    sections: [
      {
        title: "Odontología Digital",
        description: "Impresiones digitales e imágenes 3D para un diagnóstico y una planificación del tratamiento precisos.",
        benefits: [
          "Captura dental digital rápida y cómoda.",
          "Comodidad significativamente mayor que con las impresiones.",
          "Posibilidad de visualizar los resultados de su tratamiento.",
          "Contribuye a un tratamiento más rápido y agradable."
        ]
      },
      {
        title: "Láser Dental: La Luz Curativa",
        description: "Un láser dental es un instrumento versátil que reemplaza muchas herramientas convencionales y apoya la curación. Funciona de manera precisa, eficiente y segura. Beneficios del Láser Dental para usted:",
        benefits: [
          "Apoya la curación de encías, hueso y más.",
          "Permite intervenciones quirúrgicas menores.",
          "Ayuda en la esterilización de conductos radiculares.",
          "Se utiliza para detener el sangrado en procedimientos.",
          "Tratamiento efectivo de aftas y herpes.",
          "Apoya el tratamiento de la periodontitis.",
          "Ayuda en la desensibilización de cuellos dentales sensibles."
        ]
      },
      {
        title: "Tecnología de Implantes",
        description: "Sistemas de implantes avanzados para una integración óptima y un éxito a largo plazo.",
        benefits: [
          "Materiales biocompatibles de alta calidad",
          "Planificación guiada por ordenador para la máxima seguridad",
          "Resultados duraderos y de aspecto natural"
        ]
      },
      {
        title: "Microscopio Dental",
        description: "Precisión microscópica para tratamientos de endodoncia y procedimientos quirúrgicos finos.",
        benefits: [
          "Máxima precisión en los detalles",
          "Mayores tasas de éxito en los tratamientos de conducto",
          "Preservación de la mayor cantidad posible de estructura dental natural"
        ]
      }
    ],
    conclusion: "Al combinar estas tecnologías modernas con nuestro enfoque en la confianza y la transparencia, experimentará en SeaDent una odontología profesional, agradable y personal."
  },


  // Other sections
  implants: {
    title: "Implantes – Para una mejor calidad de vida",
    intro: "Los implantes dentales son la forma más moderna y natural de reponer los dientes perdidos. No solo ofrecen una estética perfecta, sino que también le devuelven la sensación y la seguridad de sus propios dientes. En nuestra clínica de Palma apostamos por los más altos estándares de calidad y los procedimientos más modernos.",
    benefitsTitle: "Ventajas de los implantes",
    benefit1: "Aspecto y sensación naturales, comparables a los propios dientes",
    benefit2: "Mejora de la función masticatoria y de la capacidad de hablar",
    benefit3: "Solución duradera con una alta tasa de éxito",
    benefit4: "Preservación de la estructura ósea de la mandíbula",
    qualityTitle: "Máxima calidad y precisión",
    quality: "Utilizamos únicamente materiales de alta calidad y procedimientos de planificación digital de última generación. Así le garantizamos un resultado preciso y duradero que se adapta perfectamente a usted.",
    experienceTitle: "Experiencia de tratamiento agradable",
    experience: "Gracias a las técnicas mínimamente invasivas y a la anestesia suave, el tratamiento con nosotros es especialmente delicado. Nuestro objetivo es que se sienta cómodo y seguro durante todo el proceso.",
    processTitle: "El camino hacia sus nuevos implantes",
    step1Title: "Consulta",
    step1: "Conversación detallada y planificación individual",
    step2Title: "Implantación",
    step2: "Procedimiento suave bajo anestesia local",
    step3Title: "Cicatrización",
    step3: "Integración del implante con el hueso de la mandíbula",
    step4Title: "Prótesis dental",
    step4: "Creación e inserción del reemplazo dental individual"
  },
  veneers: {
    title: "Carillas – Para su sonrisa radiante",
    intro: "Las láminas cerámicas ultrafinas, conocidas como carillas, ofrecen una solución elegante para corregir permanentemente pequeñas imperfecciones estéticas en los dientes frontales. Ya se trate de decoloraciones, pequeños espacios o ligeras desalineaciones, le ayudamos a conseguir una sonrisa armoniosa y natural.",
    imageAlt: "Tratamiento de carillas en SeaDent Mallorca",
    description: "Las carillas son láminas fabricadas individualmente que se adhieren firmemente a la superficie del diente. Se caracterizan por su alta biocompatibilidad y una estética difícil de distinguir de los dientes naturales. En solo unas pocas sesiones, transformamos su sonrisa y le damos una nueva confianza en sí mismo."
  },
  legalNotice: {
    title: "Aviso Legal",
    german: {},
    english: {},
    spanish: {}
  }
};